import React from "react";
import { Trans } from "react-i18next";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../utils/AuthenticatedFetch";
import { getLoggedUser } from "../auth/Signin";
import { getSetting } from "../Settings/InstallationSettings";
import {
  Alert,
  Classes,
  Intent,
  OverlayToaster,
  Position,
} from "@blueprintjs/core";
import i18n from "../../i18n";
import { Navigate } from "react-router-dom";

export default class RedboxIframe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_email: getLoggedUser() + "_supervision@rcs.com",
      user_firstname: getLoggedUser(),
      user_lastname: "supervision",
      token: undefined,
      iframeUrl: undefined,
      entryData: undefined,
    };
    this.toasterRef = React.createRef(null);
  }

  // Récupération du Token et mise en forme de l'url de l'iframe
  fetchToken = () => {
    const { protocol, host } = window.location;
    authenticatedGetFetch(
      "/booking/redbox",
      (response) => {
        if (response?.token) {
          this.setState({ token: response.token });
          const params = {
            user_email: this.state.user_email,
            user_firstname: this.state.user_firstname,
            user_lastname: this.state.user_lastname,
            token: response.token,
            url: `${protocol}//${host}`,
          };

          const jsonParams = JSON.stringify(params);
          const base64Params = btoa(jsonParams);
          this.setState({
            iframeUrl: `${getSetting("redbox url")}${
              this.props.page
            }?data=${encodeURIComponent(base64Params)}`,
          });
        } else {
          console.error("Failed to retrieve token. Response:", response);
        }
      },
      null,
      null,
      null,
      false,
      { cache: "reload" }
    );
  };

  handleMessage = (event) => {
    if (
      event?.data?.type === "forceEntry" ||
      event?.data?.type === "forceExit"
    ) {
      this.setState({ entryData: event.data });
    }
  };

  componentDidMount() {
    if (getSetting("redbox url", "") !== "") {
      this.fetchToken();
      window.addEventListener("message", this.handleMessage);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page) {
      this.fetchToken();
    }
  }

  render() {
    // redirect to error mage if no redbox url declared (standalone resaweb or other website)
    if (getSetting("redbox url", "") === "") return <Navigate to="/404" />;

    const AlertMsg =
      this.state.entryData?.type === "forceEntry" ? (
        <Trans>do you want to force the entry of booking</Trans>
      ) : (
        <Trans>do you want to force the exit of booking</Trans>
      );
    const CheckinoutOKMsg =
      this.state.entryData?.type === "forceEntry" ? (
        <Trans>checkin successful!</Trans>
      ) : (
        <Trans>checkout successful!</Trans>
      );
    const CheckinoutKOMsg =
      this.state.entryData?.type === "forceEntry" ? (
        <Trans>checkin error</Trans>
      ) : (
        <Trans>checkout error</Trans>
      );

    return (
      <div style={{ height: "80vh", width: "100%" }}>
        <iframe
          id="myIframe"
          title="Booking"
          src={this.state.iframeUrl}
          allowfullscreen
          loading="lazy"
          width="100%"
          height="100%"
        />
        <Alert
          confirmButtonText={<Trans>confirm</Trans>}
          cancelButtonText={i18n.t("cancel")}
          isOpen={
            this.state.entryData?.type === "forceEntry" ||
            this.state.entryData?.type === "forceExit"
          }
          onClose={() => this.setState({ entryData: undefined })}
          onCancel={() => this.setState({ entryData: undefined })}
          onConfirm={() => {
            authenticatedPostFetch(
              "/booking/checkinout",
              {
                bookingId: this.state.entryData.bookingId,
                type: this.state.entryData.type,
                srv: this.state.entryData.parkingId,
              },
              (code, authResponse) => {
                if (this.toasterRef.current) {
                  if (code < 400) {
                    this.toasterRef.current.show({
                      message: CheckinoutOKMsg,
                      intent: Intent.SUCCESS,
                      icon: "tick",
                      timeout: 3000,
                    });
                  } else {
                    this.toasterRef.current.show({
                      message: CheckinoutKOMsg,
                      intent: Intent.DANGER,
                      icon: "error",
                      timeout: 3000,
                    });
                  }
                }
                this.setState({ entryData: undefined });
                const iframe = document.getElementById("myIframe");
                if (iframe)
                  iframe.contentWindow.postMessage(
                    { type: "checkstate", code: code },
                    getSetting("redbox url")
                  );
                else console.error("L'iframe n'existe pas !");
              }
            );
          }}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="primary"
          icon="endorsed"
        >
          {AlertMsg}
        </Alert>
        <OverlayToaster
          className={Classes.TOAST_CONTAINER}
          usePortal={true}
          ref={this.toasterRef}
          position={Position.BOTTOM_LEFT}
        />
      </div>
    );
  }
}
